module.exports = __webpack_public_path__ + "img/pen.b41572f3.svg";